import { Button, styled } from "@mui/material";

const PrimaryButton = styled(Button)(({ theme }) => ({
    width: "100%",
    backgroundColor: "#1F4CB3",
    borderRadius: "8px",
    fontFamily: "Geist, sans-serif",
    fontSize: "14px",
    "&:hover": {
        backgroundColor: "#1E5EDB"
    },
    "&:active": {
        backgroundColor: "#1E428A"
    },
    "&:disabled": {
        backgroundColor: "#C1CACB"
    },
    marginTop: "8px",
    marginBottom: "8px",
    boxShadow: "none",

    // Dark mode styles using media query
    '@media (prefers-color-scheme: dark)': {
        backgroundColor: "#93CDFD",
        color: "#000000",
        "&:hover": {
            backgroundColor: "#60B1FA"
        },
        "&:active": {
            backgroundColor: "#BFE0FE"
        },
        "&:disabled": {
            backgroundColor: "#889192"
        }
    }
}));

export default PrimaryButton;